"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
var angular_1 = __importDefault(require("angular"));
var config_1 = require("./constants/config");
var auth_constants_1 = require("./constants/auth-constants");
var timezones_1 = require("./constants/timezones");
exports.Constants = angular_1.default.module("constants", [
    config_1.Config.name,
    auth_constants_1.Auth.name,
    timezones_1.Timezones.name,
]);
